<template>
  <div class="wholeContext">
    <app-sidebar></app-sidebar>
    <app-header :transDataSet="transDate"></app-header>
    <div class="appContext">
      <div class="container">
        <div class="area_wrap">
          <div class="text_wrap caution list">
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>갑상선절제술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://youtu.be/9RJtlj8I_3U" target="_blank">
                          <button>갑상선암 수술과 합병증 유튜브 동영상</button>
                        </a>
                        <a href="https://youtu.be/5riCWtuLhdw" target="_blank">
                          <button>갑상선암 자주 묻는 질문 유튜브 동영상</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1BgTMdXSIW9jF6fAJdBLpIfqPX61RSpzX/view?usp=sharing" target="_blank">
                        <button type="button">갑상선절제술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>갑상선협부절제술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://youtu.be/9RJtlj8I_3U" target="_blank">
                          <button>갑상선암 수술과 합병증 유튜브 동영상</button>
                        </a>
                        <a href="https://cafe.naver.com/thanqseoul/317" target="_blank">
                          <button>갑상선암 수술, 협부절제술을 소개합니다</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1gcZVW_-LXBmN84lzMZ8bpuUqRfEYKOCU/view?usp=sharing" target="_blank">
                        <button type="button">갑상선협부절제술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>측경부림프절절제술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://youtu.be/1C0Mz9yQCwY" target="_blank">
                          <button>갑상선암 및 두경부암 림프절 절제술 개념과 종류</button>
                        </a>
                        <a href="https://youtu.be/6l5ht3haorc" target="_blank">
                          <button>갑상선암 및 두경부암 측경부 림프절 절제술 합병증</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/15Za4lkprryewGVWRZ3mEFhsx4LDjPDK5/view?usp=sharing" target="_blank">
                        <button type="button">측경부림프절절제술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>갑상선결절시술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/2126" target="_blank">
                          <button>갑상선 양성결절의 고주파열치료술은 언제 하는가</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1YXs0hZlfNU_Z9SyC2L-fwEpHcC6HlWvV/view?usp=sharing" target="_blank">
                        <button type="button">갑상선결절시술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>후두암레이저수술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/454" target="_blank">
                          <button>후두암의 증상, 진단 및 치료 동영상</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1MLak17I6J47AICH0PaiOlqb1iBuX3PjQ/view?usp=sharing" target="_blank">
                        <button type="button">후두암레이저수술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>구강암 구강내수술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/1383" target="_blank">
                          <button>설암(구강암)의 진단과 수술</button>
                        </a>
                        <a href="https://cafe.naver.com/thanqseoul/1194" target="_blank">
                          <button>국소마취로도 가능한 조기 구강암 수술</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1_AYclH9obRpE-z_82kV3CBBruSWxgxij/view?usp=sharing" target="_blank">
                        <button type="button">구강암 구강내수술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>인두암 구강내수술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/1382" target="_blank">
                          <button>편도암(구인두암)의 진단과 수술</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1Z5BMnw0GjXReUbcVnV4E6mq9SNpGAjFM/view?usp=sharing" target="_blank">
                        <button type="button">인두암 구강내수술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>이하선종양수술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/305" target="_blank">
                          <button>이하선종양은 왜 모두 수술해야 할까?</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1YRAO1nc5IQ3QBI6CAnrDvnZwhv84EXRR/view?usp=sharing" target="_blank">
                        <button type="button">이하선종양수술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>악하선절제술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/9" target="_blank">
                          <button>악하선(턱밑샘) 타석을 입 안에서 제거하기</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1sFS_ZqZWJ9ClDMjhkcGZNTpLBhXhfEXl/view?usp=sharing" target="_blank">
                        <button type="button">악하선절제술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>설하선절제술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/74" target="_blank">
                          <button>몰입성 하마종(경부하마종)의 구강내 수술 (설하선 절제술)</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1YQwtC_rq8KogNYaLLGU0XFyeuH1gev6H/view?usp=sharing" target="_blank">
                        <button type="button">설하선절제술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>구강내타석제거술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/276" target="_blank">
                          <button>악하선(턱밑샘) 타석을 입 안에서 제거하기</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1sPYYMnvTJf75sX9H66hqKe1RMXVnm9MT/view?usp=sharing" target="_blank">
                        <button type="button">구강내타석제거술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>양성종양수술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/200" target="_blank">
                          <button>두경부 양성종양의 진단과 치료</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1ypAwS5iYXyq2rpn2wIVZmnin57NBLT_K/view?usp=sharing" target="_blank">
                        <button type="button">양성종양수술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>림프절절제조직검사</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/288" target="_blank">
                          <button>목멍울은 어떤 경우에 암을 의심하나</button>
                        </a>
                        <a href="https://cafe.naver.com/thanqseoul/1394" target="_blank">
                          <button>결핵성 림프절염은 진단이 어려운가요?</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1wVzbU1d3W4n-TycwPKx8HXFSJ5fGpP4F/view?usp=sharing" target="_blank">
                        <button type="button">림프절절제조직검사</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>갑상설관낭종절제술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/38" target="_blank">
                          <button>갑상설관낭종은 꼭 수술해야 하나요?</button>
                        </a>
                        <a href="https://cafe.naver.com/thanqseoul/50" target="_blank">
                          <button>갑상설관낭종의 수술 방법</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/17lUHrnYnNS4p_6yh4vTjBYk8SKn_IPeF/view?usp=sharing" target="_blank">
                        <button type="button">갑상설관낭종절제술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>갑상설관낭종 알코올경화술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/38" target="_blank">
                          <button>갑상설관낭종은 꼭 수술해야 하나요?</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1GuSPXCKjq2-yNmW9M4xEfC69Mn_tzJVi/view?usp=sharing" target="_blank">
                        <button type="button">갑상설관낭종 알코올경화술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>편도절제술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/579" target="_blank">
                          <button>편도선 수술에 대해 자주 묻는 질문</button>
                        </a>
                        <a href="https://cafe.naver.com/thanqseoul/605" target="_blank">
                          <button>피타(PITA) 수술법이란?</button>
                        </a>
                        <a href="https://cafe.naver.com/thanqseoul/1933" target="_blank">
                          <button>코블레이터(고주파수술기)를 이용한 편도절제술(피타수술)</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1K4wPo-JO8kqm3ryMRFIXI_9Y-YVRS3z_/view?usp=sharing" target="_blank">
                        <button type="button">편도절제술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>후두미세수술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/558" target="_blank">
                          <button>성대 결절과 폴립</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1gbKKBX5omIuuP9K27MSn5ux0NEy0BM-F/view?usp=sharing" target="_blank">
                        <button type="button">후두미세수술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>성대주입술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="detail_text">
                      <p class="dt_p">아래 동의서 내용을 읽어 보시기 전에 아래 링크를 확인하시면 질병과 수술을 이해하는 데 도움이 됩니다.</p>
                      <div class="detail_url">
                        <a href="https://cafe.naver.com/thanqseoul/1438" target="_blank">
                          <button>성대마비의 치료 중 성대주입술</button>
                        </a>
                      </div>
                    </div>
                    <div class="tw_item btnItem">
                      <a href="https://drive.google.com/file/d/1ji4MskcJaYjR-LBjfHrmYea3opYUexY4/view?usp=sharing" target="_blank">
                        <button type="button">성대주입술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
            <div class="tw_accordion">
              <BaseAccordion :basic="basic">
                <template v-slot:title>
                  <div class="tw_item other">
                    <div class="tw_title">
                      <h2>기타수술</h2>
                    </div>
                  </div>
                </template>
                <template v-slot:content>
                  <div class="tw_detail">
                    <div class="tw_item btnItem other">
                      <a href="https://drive.google.com/file/d/1sMlMpucEpnQFKiGnXLHp-0-XIKD0kChb/view?usp=sharing" target="_blank">
                        <button type="button">기타수술</button>
                      </a>
                    </div>
                  </div>
                </template>
              </BaseAccordion>
            </div>
          </div>
          <div class="text_wrap surgery">
            <p>수술동의서의 다른 공통 항목들은 아래를 눌러 확인하시기 바랍니다.</p>
            <div class="tw_btn">
              <a href="https://drive.google.com/file/d/1WGcOp9HK5Xh643NdE272qM-GDFxnUHPn/view?usp=sharing" target="_blank">
                <button>수술동의서 공통 사항 보기</button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <add-popup v-if="checkPopup"
               :popupSet="popupSet"/>
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader'
import AppSidebar from '@/components/AppSidebar'
import AddPopup from '@/components/AddPopup'
import BaseAccordion from '@/components/BaseAccordion'
import axios from 'axios'
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex'
export default {
  data () {
    return {
      basic: {
        isShow: false,
        isOpen: false
      },
      popupSet: {
        title: '',
        modalImg: 'alert_cn.svg',
        content: '',
        confirmBtnText: '확인',
        count: 'single'
      },
      transDate: {
        headerName: '수술 동의서',
        prevUrl: '/'
      }
    }
  },
  computed: {
    ...mapGetters([

    ]),
    ...mapState([
      'checkPopup'
    ])
  },
  methods: {
    ...mapMutations([
      'SET_POPUP'
    ]),
    ...mapActions([

    ]),
    async fileDown () {
      console.log('e.target: ', event.target.innerText)
      const name = event.target.innerText + '.pdf'
      const url = name
      const config = {
        method: 'get',
        url: url,
        responseType: 'blob'
      }
      try {
        const response = await axios(config)
        console.log('file download')
        const fileURL = window.URL.createObjectURL(new Blob([response.data]))
        const fileLink = document.createElement('a')
        fileLink.href = fileURL
        fileLink.setAttribute('download', '.pdf')
        document.body.appendChild(fileLink)
        fileLink.click()
      } catch (e) {
        console.log('error: ', e)
      }
    }
  },
  components: {
    AppHeader,
    AppSidebar,
    AddPopup,
    BaseAccordion
  }
}
</script>

<style lang="scss" scoped>
</style>
